// Значките на доставка: тип документ (ФАКТУРА / СТОКОВА) и статус на плащане
// (Платена · Неплатена · По фактура · Анулирана). Заварен запис отпреди
// плащането показва тире — нищо не знаем за плащането му.
import { useTranslation } from "react-i18next";
import type { Delivery, DeliveryDocumentType } from "../../../../api/inventory";
import { DocTypeBadge, StatusPill } from "../../components/list/ListBits";
import { docTypeOf, payKeyOf } from "./deliveryMeta";

export const DeliveryTypeBadge = ({
  documentType,
}: {
  documentType?: DeliveryDocumentType | null;
}) => {
  const { t } = useTranslation();
  const type = docTypeOf({ documentType });
  return (
    <DocTypeBadge tone={type}>
      {type === "note" ? t("inventoryPage.docTypeNote") : t("inventoryPage.docTypeInvoice")}
    </DocTypeBadge>
  );
};

export const DeliveryPaymentPill = ({ delivery }: { delivery: Delivery }) => {
  const { t } = useTranslation();
  const key = payKeyOf(delivery);
  if (key === "untracked") return <span className="text-faint">—</span>;
  const tone = key === "paid" ? "ok" : key === "unpaid" ? "danger" : "neutral";
  const label = {
    paid: t("inventoryPage.payPaid"),
    unpaid: t("inventoryPage.payUnpaid"),
    byinv: t("inventoryPage.payByInvoice"),
    annulled: t("inventoryPage.payAnnulled"),
  }[key];
  const method =
    key === "paid" && delivery.paymentMethod
      ? ` · ${t(`inventoryPage.payMethod_${delivery.paymentMethod}`)}`
      : "";
  return <StatusPill tone={tone}>{label + method}</StatusPill>;
};
